// Traducciones Español/Inglés para "Alza Tu Voz"

export const translations = {
  es: {
    // General
    appName: "Alza Tu Voz",
    appSubtitle: "Plataforma de Autodiagnóstico Educativo",
    credits: "Una aplicación de LAB XXI y desarrollado por Boost Change",
    
    // Navigation
    home: "Inicio",
    questionnaire: "Cuestionario",
    results: "Resultados",
    actionPlan: "Plan de Acción",
    
    // Welcome/Home
    welcomeTitle: "Bienvenido a Alza Tu Voz",
    welcomeSubtitle: "Descubre qué tan inclusivas son las prácticas de tu organización",
    welcomeDescription: "Esta herramienta digitaliza la metodología de LAB XXI para ayudar a organizaciones a evaluar y mejorar sus prácticas de inclusión con adolescentes.",
    startDiagnosis: "Iniciar Diagnóstico",
    continueProgress: "Continuar Diagnóstico",
    viewResults: "Ver Resultados",
    
    // Features
    featureReflexive: "Reflexiva",
    featureReflexiveDesc: "Evalúa tus prácticas actuales de forma honesta",
    featurePractical: "Práctica",
    featurePracticalDesc: "Recibe recomendaciones basadas en experiencias reales",
    featureAction: "Orientada a la Acción",
    featureActionDesc: "Crea un plan de mejora con compromisos concretos",
    
    // Questionnaire
    questionnaireTitle: "Cuestionario de Autodiagnóstico",
    questionProgress: "Pregunta {current} de {total}",
    dimension: "Dimensión",
    previous: "Anterior",
    next: "Siguiente",
    finish: "Finalizar",
    dontKnow: "No sé",
    
    // Scale Labels
    scale1: "Nunca / Muy raro",
    scale2: "Pocas veces",
    scale3: "A veces",
    scale4: "Frecuentemente",
    scale5: "Siempre / Muy frecuente",
    
    // Results
    resultsTitle: "Resultados del Diagnóstico",
    resultsSubtitle: "Aquí está el análisis de las prácticas de tu organización",
    overallScore: "Puntaje General",
    dimensionScores: "Puntajes por Dimensión",
    radarChartTitle: "Perfil de Inclusión",
    saveReport: "Guardar Reporte (PDF)",
    goToActionPlan: "Ver Plan de Acción",
    restartDiagnosis: "Reiniciar Diagnóstico",
    
    // Score Levels (Nivel de Inclusión: 1=crítico, 5=excelente)
    scoreLow: "Área Crítica / Por Explorar",
    scoreMedium: "En Proceso",
    scoreHigh: "Fortaleza / Práctica Inclusiva",
    
    // Action Plan
    actionPlanTitle: "Plan de Acción",
    actionPlanSubtitle: "Buenas prácticas recomendadas para mejorar",
    recommendedPractices: "Prácticas Recomendadas",
    myCommitments: "Mis Compromisos",
    noCommitments: "Aún no has seleccionado ningún compromiso. Explora las prácticas y marca los tips que te gustaría implementar.",
    viewDetails: "Ver Detalles",
    
    // Practice Detail Sheet
    whoImplements: "¿Quién puede implementarla?",
    whatAndWhy: "¿De qué trata y por qué la usamos?",
    resultsAchieved: "¿Qué resultados ha tenido?",
    challengeFaced: "Desafío enfrentado",
    solutionResponse: "Cómo lo resolvimos",
    tipsToApply: "Tips para aplicar esta práctica",
    selectTipsToCommit: "Selecciona los tips que te comprometes a implementar",
    
    // Footer
    footerCopyright: "© {year} LAB XXI. Todos los derechos reservados.",
    aboutProject: "Acerca del Proyecto",
    viewCredits: "Ver Créditos",
    
    // Modal
    creditsTitle: "Créditos",
    close: "Cerrar",
    
    // Dimensions
    dimensions: {
      "Convocatoria": "Convocatoria",
      "Comunicación": "Comunicación",
      "Metodologías": "Metodologías",
      "Logística": "Logística",
      "Aliados externos": "Aliados externos",
      "Retroalimentación": "Retroalimentación"
    },
    
    dimensionDescriptions: {
      "Convocatoria": "Cómo llegamos a adolescentes diversos",
      "Comunicación": "Materiales y lenguaje inclusivo",
      "Metodologías": "Dinámicas y participación equitativa",
      "Logística": "Transporte, alimentación y recursos",
      "Aliados externos": "Familias y redes de apoyo",
      "Retroalimentación": "Escucha y mejora continua"
    },
    
    // Print
    printTitle: "Reporte de Autodiagnóstico - Alza Tu Voz",
    printDate: "Fecha del diagnóstico",
    printGeneratedBy: "Generado por la plataforma Alza Tu Voz de LAB XXI",
    
    // How it Works Section
    howItWorksTitle: "¿Cómo funciona?",
    howItWorksSubtitle: "Un proceso simple para evaluar y mejorar las prácticas de tu organización",
    step1Title: "Responde",
    step1Desc: "Completa el cuestionario de 18 preguntas",
    step2Title: "Analiza",
    step2Desc: "Visualiza tu perfil de inclusión",
    step3Title: "Aprende",
    step3Desc: "Explora buenas prácticas recomendadas",
    step4Title: "Actúa",
    step4Desc: "Crea tu plan de compromisos"
  },
  
  en: {
    // General
    appName: "Raise Your Voice",
    appSubtitle: "Educational Self-Diagnosis Platform",
    credits: "An application by LAB XXI and developed by Boost Change",
    
    // Navigation
    home: "Home",
    questionnaire: "Questionnaire",
    results: "Results",
    actionPlan: "Action Plan",
    
    // Welcome/Home
    welcomeTitle: "Welcome to Raise Your Voice",
    welcomeSubtitle: "Discover how inclusive your organization's practices are",
    welcomeDescription: "This tool digitizes LAB XXI's methodology to help organizations assess and improve their inclusion practices with adolescents.",
    startDiagnosis: "Start Diagnosis",
    continueProgress: "Continue Diagnosis",
    viewResults: "View Results",
    
    // Features
    featureReflexive: "Reflective",
    featureReflexiveDesc: "Honestly evaluate your current practices",
    featurePractical: "Practical",
    featurePracticalDesc: "Receive recommendations based on real experiences",
    featureAction: "Action-Oriented",
    featureActionDesc: "Create an improvement plan with concrete commitments",
    
    // Questionnaire
    questionnaireTitle: "Self-Diagnosis Questionnaire",
    questionProgress: "Question {current} of {total}",
    dimension: "Dimension",
    previous: "Previous",
    next: "Next",
    finish: "Finish",
    dontKnow: "Don't know",
    
    // Scale Labels
    scale1: "Never / Very rare",
    scale2: "Rarely",
    scale3: "Sometimes",
    scale4: "Frequently",
    scale5: "Always / Very frequent",
    
    // Results
    resultsTitle: "Diagnosis Results",
    resultsSubtitle: "Here's the analysis of your organization's practices",
    overallScore: "Overall Score",
    dimensionScores: "Scores by Dimension",
    radarChartTitle: "Inclusion Profile",
    saveReport: "Save Report (PDF)",
    goToActionPlan: "View Action Plan",
    restartDiagnosis: "Restart Diagnosis",
    
    // Score Levels (Inclusion Level: 1=critical, 5=excellent)
    scoreLow: "Critical Area / To Explore",
    scoreMedium: "In Progress",
    scoreHigh: "Strength / Inclusive Practice",
    
    // Action Plan
    actionPlanTitle: "Action Plan",
    actionPlanSubtitle: "Recommended best practices for improvement",
    recommendedPractices: "Recommended Practices",
    myCommitments: "My Commitments",
    noCommitments: "You haven't selected any commitments yet. Explore the practices and check the tips you'd like to implement.",
    viewDetails: "View Details",
    
    // Practice Detail Sheet
    whoImplements: "Who can implement it?",
    whatAndWhy: "What is it and why do we use it?",
    resultsAchieved: "What results has it achieved?",
    challengeFaced: "Challenge faced",
    solutionResponse: "How we solved it",
    tipsToApply: "Tips to apply this practice",
    selectTipsToCommit: "Select the tips you commit to implement",
    
    // Footer
    footerCopyright: "© {year} LAB XXI. All rights reserved.",
    aboutProject: "About the Project",
    viewCredits: "View Credits",
    
    // Modal
    creditsTitle: "Credits",
    close: "Close",
    
    // Dimensions
    dimensions: {
      "Convocatoria": "Outreach",
      "Comunicación": "Communication",
      "Metodologías": "Methodologies",
      "Logística": "Logistics",
      "Aliados externos": "External Allies",
      "Retroalimentación": "Feedback"
    },
    
    dimensionDescriptions: {
      "Convocatoria": "How we reach diverse adolescents",
      "Comunicación": "Inclusive materials and language",
      "Metodologías": "Dynamics and equitable participation",
      "Logística": "Transportation, food and resources",
      "Aliados externos": "Families and support networks",
      "Retroalimentación": "Listening and continuous improvement"
    },
    
    // Print
    printTitle: "Self-Diagnosis Report - Raise Your Voice",
    printDate: "Diagnosis date",
    printGeneratedBy: "Generated by the Raise Your Voice platform by LAB XXI",
    
    // How it Works Section
    howItWorksTitle: "How does it work?",
    howItWorksSubtitle: "A simple process to evaluate and improve your organization's practices",
    step1Title: "Answer",
    step1Desc: "Complete the 18-question questionnaire",
    step2Title: "Analyze",
    step2Desc: "View your inclusion profile",
    step3Title: "Learn",
    step3Desc: "Explore recommended best practices",
    step4Title: "Act",
    step4Desc: "Create your commitment plan"
  }
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let result = translations[lang];
  
  for (const k of keys) {
    if (result && result[k] !== undefined) {
      result = result[k];
    } else {
      return key; // Return key if translation not found
    }
  }
  
  return result;
};

export default translations;
